/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const BookIcon = (props) => {
  return (
    <StyledIcon {...props}>
      <rect width="48" height="48" rx="8" fill="#F0F4F7" />
      <path
        d="M24 12C21.6266 12 19.3066 12.7038 17.3332 14.0224C15.3598 15.3409 13.8217 17.2151 12.9135 19.4078C12.0052 21.6005 11.7676 24.0133 12.2306 26.3411C12.6936 28.6689 13.8365 30.807 15.5147 32.4853C17.193 34.1635 19.3311 35.3064 21.6589 35.7694C23.9867 36.2324 26.3995 35.9948 28.5922 35.0866C30.7849 34.1783 32.6591 32.6402 33.9776 30.6668C35.2962 28.6934 36 26.3734 36 24C35.9967 20.8184 34.7314 17.768 32.4817 15.5183C30.232 13.2686 27.1816 12.0033 24 12ZM28.6031 25.0831L23.1508 28.2215C22.9644 28.3322 22.7521 28.3916 22.5354 28.3938C22.3145 28.3938 22.0977 28.3343 21.9077 28.2215C21.7176 28.1147 21.5593 27.9592 21.449 27.7711C21.3387 27.5829 21.2804 27.3689 21.28 27.1508V20.8492C21.2804 20.6311 21.3387 20.4171 21.449 20.2289C21.5593 20.0408 21.7176 19.8853 21.9077 19.7785C22.0948 19.6704 22.307 19.6136 22.5231 19.6136C22.7391 19.6136 22.9514 19.6704 23.1385 19.7785L28.5908 22.9169C28.7862 23.0224 28.9494 23.1787 29.0631 23.3694C29.1769 23.5601 29.237 23.778 29.237 24C29.237 24.222 29.1769 24.4399 29.0631 24.6306C28.9494 24.8213 28.7862 24.9776 28.5908 25.0831H28.6031Z"
        fill="#9AAFBF"
      />
    </StyledIcon>
  );
};

export default BookIcon;
